import { formatText } from "../pushNotificationMessage";

const messages = async ({ actionType, notifyContent }) => {

    const message = {
        newEnquiry: {
            title: `Nouvelle enquête`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `Recusada`,
            message: `${formatText(notifyContent['userName'])}: La réservation est refusée`
        },
        approved: {
            title: `Aprovado`,
            message: `${formatText(notifyContent['userName'])}: La réservation est approuvée`
        },
        newMessage: {
            title: `Nouveau message`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `La réservation est annulée`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        newBooking: {
            title: `Nouvelle réservation`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `Nouvelle réservation`,
            message: `${formatText(notifyContent['userName'])}: Votre demande est pré-approuvée`
        },
        listApproved: {
            title: `L'administrateur a vérifié votre annonce`,
            message: `${formatText(notifyContent['userName'])} : L'administrateur a vérifié votre annonce ${notifyContent['listTitle']} . Veuillez la publier pour obtenir des réservations.`
        },
        listDeclined: {
            title: `L'administrateur a refusé votre annonce`,
            message: `${formatText(notifyContent['userName'])} : L'administrateur a refusé votre demande d'inscription pour ${notifyContent['listTitle']} pour la raison ${notifyContent['reason']}. Veuillez mettre à jour les informations de l'inscription et la soumettre pour approbation.`
        },
        noHostPayout: {
            title: `Détails de paiement manquants`,
            message: `${formatText(notifyContent['userName'])}:Mise à jour ! Veuillez mettre à jour vos informations de paiement pour recevoir les paiements de réservation.`
        },
        approvedDocument: {
            title: `Document approuvé !`,
            message: `Votre document a été approuvé avec succès.`
        },
        rejectDocument: {
            title: `Document rejeté !`,
            message: `Votre document a été refusé par l'administrateur. Veuillez le contacter pour plus d'informations.`
        }
    }

    return message[actionType]
}
export default messages;